module.exports = __webpack_public_path__ + "static/media/Valentinos.049ff08d.jpg";